// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import kanjis from '../consts/kanjis';
import kanjiDictionary from '../consts/kanjiDictionary';

function isSuffixSuggestion(item) {
    return item.Meanings.some((meaning) => /suffix/i.test(meaning));
}

export function getKanjiSuggestionsFromHiragana(hiraganaWord) {
    const vocabularySuggestions = kanjiDictionary
        .filter((entry) => entry.reading === hiraganaWord && entry.meanings)
        .flatMap((entry) => entry.candidates.map((candidate) => ({
            Kanji: candidate,
            Meanings: entry.meanings,
            ReadingHiragana: [entry.reading]
        })));
    const kanjiSuggestions = kanjis
        .filter((item) => item.ReadingHiragana.includes(hiraganaWord))
        .filter((item) => !vocabularySuggestions.some((suggestion) => suggestion.Kanji === item.Kanji));

    return [...vocabularySuggestions, ...kanjiSuggestions]
        .map((item, sourceIndex) => ({ item, sourceIndex }))
        .sort((left, right) => {
            const suffixDifference = Number(isSuffixSuggestion(left.item)) - Number(isSuffixSuggestion(right.item));

            // A completed word is treated as standalone input, so ordinary
            // vocabulary and numbers should precede suffix-only alternatives.
            // Keep the dictionary's established order within each group.
            return suffixDifference || left.sourceIndex - right.sourceIndex;
        })
        .map(({ item }) => item);
}
